import { QUESTIONNAIRE_EVALUATION as MODULE_PREFIX } from '../constants';
export const QUESTIONNAIRE_EVALUATION_OVERRIDE_SCORE_REQUEST = `${MODULE_PREFIX}_OVERRIDE_SCORE_REQUEST`;
export const QUESTIONNAIRE_EVALUATION_OVERRIDE_SCORE_SUCCESS = `${MODULE_PREFIX}_OVERRIDE_SCORE_SUCCESS`;
export const questionnaireEvaluationOverrideScoreRequestAction = (requestData) => ({
    type: QUESTIONNAIRE_EVALUATION_OVERRIDE_SCORE_REQUEST,
    payload: requestData
});
export const questionnaireEvaluationOverrideScoreSuccessAction = () => ({
    type: QUESTIONNAIRE_EVALUATION_OVERRIDE_SCORE_SUCCESS,
    payload: null
});
//# sourceMappingURL=questionnaireEvaluationOverrideScoreActions.js.map